module.exports = __webpack_public_path__ + "static/people_pop1-f73ff92f7fa9f0fb17485b1e753c5c5f.png";